import { TFunction } from "@impero-com/common/utils/i18n";
import { ModeConfig } from "@impero-com/ui";

export function getFilterModeConfig(t: TFunction): ModeConfig {
    return {
        options: [
            { label: t("FilterBar_OperatorIs"), value: "is" },
            { label: t("FilterBar_OperatorIsNot"), value: "isNot" },
        ],
        defaultMode: "is",
    };
}

export function getStringFilterModeConfig(t: TFunction): ModeConfig {
    return {
        options: [
            { label: t("FilterBar_OperatorIs"), value: "is" },
            { label: t("FilterBar_OperatorIsNot"), value: "isNot" },
            { label: t("FilterBar_OperatorContains"), value: "contains" },
            { label: t("FilterBar_OperatorNotContains"), value: "notContains" },
        ],
        defaultMode: "is",
        textFilterPlaceholder: t("FilterBar_TextFilterPlaceholder"),
    };
}

export function getContainsOnlyFilterModeConfig(t: TFunction): ModeConfig {
    return {
        options: [
            { label: t("FilterBar_OperatorContains"), value: "contains" },
            { label: t("FilterBar_OperatorNotContains"), value: "notContains" },
        ],
        defaultMode: "contains",
        textFilterPlaceholder: t("FilterBar_TextFilterPlaceholder"),
    };
}
